import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check tab permissions if allowed_tabs is configured
  const allowedTabs = Array.isArray(user.allowed_tabs) ? user.allowed_tabs : [];
  if (allowedTabs.length > 0) {
    const currentPath = (location.pathname || '').toLowerCase();
    const isDashboard = currentPath === '/dashboard' || currentPath === '/' || currentPath === '';
    const isSecurityAllowed =
      (currentPath === '/users' || currentPath.startsWith('/security')) &&
      allowedTabs.includes('/security/login-history');

    const isExplicitlyAllowed = allowedTabs.some((tab) => {
      const t = String(tab).toLowerCase();
      return currentPath === t || currentPath.startsWith(`${t}/`);
    });

    if (!isDashboard && !isSecurityAllowed && !isExplicitlyAllowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default PrivateRoute;
